// English: перевод интерфейса. Ключ — русская строка из кода (t("…")).
// Собрано из всех t(...) в src/; при новых надписях — добавить сюда.
const dict = {
  "никогда": "never",
  "только что": "just now",
  "сегодня": "today",
  "вчера": "yesterday",
  "{0} {1} назад": "{0} {1} ago",
  "день": "day",
  "дня": "days",
  "дней": "days",
  "навсегда": "forever",
  "до {0}": "until {0}",
  "Заблокировал": "Banned",
  "Разблокировал": "Unbanned",
  "Выкинул со всех устройств": "Signed out of all devices",
  "Дал права админа": "Made admin",
  "Снял права админа": "Removed admin rights",
  "Сменил тариф": "Changed plan",
  "Удалил аккаунт": "Deleted account",
  "Объявление": "Announcement",
  "Снял объявление": "Removed announcement",
  "гость": "guest",
  "AntonCards — ошибки ({0})": "AntonCards — errors ({0})",
  "Pro до какой даты? (ДД.ММ.ГГГГ, пусто — бессрочно)": "Pro until what date? (DD.MM.YYYY, empty — no end date)",
  "Не понял дату — напишите, например, 31.12.2026": "Couldn't read the date — write, for example, 31.12.2026",
  "Тариф Pro включён": "Pro plan enabled",
  "Тариф Free": "Free plan",
  "{0} заблокирован": "{0} banned",
  "Разблокировать": "Unban",
  "Разблокирован": "Unbanned",
  "Заблокировать…": "Ban…",
  "На срок или навсегда, с причиной": "For a while or forever, with a reason",
  "Выкинуть со всех устройств": "Sign out of all devices",
  "Войти снова сможет": "They can sign in again",
  "Выкинуть {0} со всех устройств?": "Sign {0} out of all devices?",
  "Выкинут со всех устройств": "Signed out of all devices",
  "Тариф: сделать Free": "Plan: make Free",
  "Тариф: сделать Pro…": "Plan: make Pro…",
  "Снять права админа": "Remove admin rights",
  "Снять права админа у {0}?": "Remove admin rights from {0}?",
  "Права админа сняты": "Admin rights removed",
  "Сделать админом": "Make admin",
  "Полный доступ к этой панели": "Full access to this panel",
  "Дать {0} права админа? Он увидит всех пользователей и сможет блокировать.": "Give {0} admin rights? They will see all users and be able to ban.",
  "Теперь админ": "Now an admin",
  "Письмо для сброса пароля": "Password reset email",
  "Письмо отправлено на {0}": "Email sent to {0}",
  "Скопировать почту": "Copy email",
  "Почта скопирована": "Email copied",
  "Удалить аккаунт…": "Delete account…",
  "Навсегда, со всеми данными": "Forever, with all data",
  "Удалить аккаунт {0} и все его проекты, тексты, словарь и статистику? Это нельзя отменить.\n\nЧтобы подтвердить, введите почту:": "Delete the account {0} and all its projects, texts, vocabulary and stats? This cannot be undone.\n\nTo confirm, type the email:",
  "Почта не совпала — аккаунт не удалён": "Email doesn't match — account not deleted",
  "Аккаунт {0} удалён": "Account {0} deleted",
  "Обзор": "Overview",
  "Пользователи{0}": "Users{0}",
  "Разборы": "Word notes",
  "Ошибки{0}": "Errors{0}",
  "Журнал": "Log",
  "Админ-панель": "Admin panel",
  "Закрыть": "Close",
  "Поиск по имени или почте": "Search by name or email",
  "Поиск": "Search",
  "Пользователей": "Users",
  "+{0} за неделю": "+{0} this week",
  "Активны сегодня": "Active today",
  "{0} за неделю": "{0} this week",
  "Заблокировано": "Banned",
  "Ошибок за сутки": "Errors in 24 h",
  "Аудиопроектов": "Audio projects",
  "Карточек": "Cards",
  "Текстов": "Texts",
  "Слов в словарях": "Words in vocabularies",
  "Недавно заходили": "Recently active",
  "Все пользователи": "All users",
  "Все": "All",
  "Активные 7 дн.": "Active 7 days",
  "Новые": "New",
  "Заблокированные": "Banned",
  "Админы": "Admins",
  "Загружаю…": "Loading…",
  "Показано:": "Shown:",
  ". Почты видны только админам.": ". Emails are visible only to admins.",
  "Админ": "Admin",
  " до {0}": " until {0}",
  "Заблокирован": "Banned",
  "почта не подтверждена": "email not confirmed",
  "это вы": "this is you",
  "был": "seen",
  "· с": "· since",
  "аудио ·": "audio ·",
  "текст": "text",
  "текста": "texts",
  "текстов": "texts",
  " · причина: {0}": " · reason: {0}",
  "Действия: {0}": "Actions: {0}",
  "Никого не нашлось.": "Nobody found.",
  "Объявление для всех пользователей": "Announcement for all users",
  "Появится полосой сверху главной на сайте, телефоне и компьютере. Каждый может закрыть его у себя.": "Shows as a strip at the top of the home screen on the site, phone and computer. Anyone can close it for themselves.",
  "Сейчас показывается:": "Currently shown:",
  "Например: «Завтра с 10:00 до 10:30 — обновление, синхронизация может быть недоступна»": "For example: “Tomorrow 10:00–10:30 — update, sync may be unavailable”",
  "Обычное": "Normal",
  "Важное": "Important",
  "Объявление снято": "Announcement removed",
  "Снять": "Remove",
  "Объявление опубликовано": "Announcement published",
  "Опубликовать": "Publish",
  "Последние 100 разборов. Удалённый разбор пропадает у всех.": "Last 100 word notes. A deleted note disappears for everyone.",
  "Разборов пока нет.": "No word notes yet.",
  "Ученик": "Learner",
  " · скрыт": " · hidden",
  "Удалить разбор «{0}» от {1}?": "Delete the note “{0}” by {1}?",
  "Удалить": "Delete",
  "Ошибки с сайта, телефона и компьютера, последние 200. «Скопировать всё» — и вставьте в чат с Claude.": "Errors from the site, phone and computer, last 200. “Copy all” — and paste into a chat with Claude.",
  "Скопировано ✓": "Copied ✓",
  "Скопировать всё": "Copy all",
  "Удалить все записи журнала ошибок?": "Delete all error log entries?",
  "Очистить": "Clear",
  "Ошибок нет.": "No errors.",
  "Кто из админов что сделал — последние 200 действий.": "Which admin did what — last 200 actions.",
  "Пока пусто.": "Empty for now.",
  "Заблокировать": "Ban",
  "Человек сразу выйдет на всех устройствах и не сможет войти до конца срока. Его данные не удаляются.": "The person is signed out on all devices right away and can't sign in until the end of the term. Their data is not deleted.",
  "1 день": "1 day",
  "7 дней": "7 days",
  "30 дней": "30 days",
  "Навсегда": "Forever",
  "Причина (увидит пользователь)": "Reason (the user will see it)",
  "Причина": "Reason",
  "Отмена": "Cancel",
  "Активность": "Activity",
  "Текущий год": "This year",
  "Вс": "Sun",
  "Пн": "Mon",
  "Вт": "Tue",
  "Ср": "Wed",
  "Чт": "Thu",
  "Пт": "Fri",
  "Сб": "Sat",
  "Прогноз 7 дней": "7-day forecast",
  "всего": "total",
  "{0} {1}: {2} карт": "{0} {1}: {2} cards",
  "Светлая тема": "Light theme",
  "Тёмная тема": "Dark theme",
  "проект": "project",
  "проекта": "projects",
  "проектов": "projects",
  "без языка": "no language",
  "Их прослушивание/чтение не попадает в статистику по языкам.": "Their listening/reading doesn't count toward per-language stats.",
  "Назначить": "Assign",
  "Назначить язык проектам": "Assign a language to projects",
  "Выберите язык для каждой папки — он применится ко всем проектам внутри. Для папок, которые пока не хотите размечать, выберите «Пропустить».": "Pick a language for each folder — it applies to every project inside. Choose “Skip” for folders you don't want to tag yet.",
  "Готово": "Done",
  "(Без папки)": "(No folder)",
  "— пропустить —": "— skip —",
  "Применить": "Apply",
  "Какой язык вы изучаете?": "Which language are you learning?",
  "AntonCards ведёт статистику отдельно для каждого языка.": "AntonCards keeps stats separately for each language.",
  "Можно поменять в любой момент.": "You can change it any time.",
  "＋ Своего нет в списке — добавить": "＋ Mine isn't listed — add it",
  "Пропустить — выберу позже": "Skip — I'll choose later",
  "Русский": "Russian",
  "Українська": "Ukrainian",
  "Введите код языка (например, cy)": "Enter a language code (e.g., cy)",
  "Код должен быть в формате BCP-47: cy, eu, nv, gd, zh-Hant…": "The code must be BCP-47: cy, eu, nv, gd, zh-Hant…",
  "Этот язык уже есть во встроенном списке": "This language is already in the built-in list",
  "«{0}» добавлен.": "“{0}” added.",
  "Удалить «{0}»? Карточки и статистика останутся.": "Delete “{0}”? Cards and stats stay.",
  "Свой язык": "Custom language",
  "Любой BCP-47 код:": "Any BCP-47 code:",
  "валлийский,": "Welsh,",
  "баскский,": "Basque,",
  "навахо.": "Navajo.",
  "Новый язык": "New language",
  "Код": "Code",
  "например, cy": "e.g., cy",
  "Название": "Name",
  "например, Cymraeg": "e.g., Cymraeg",
  "Флаг (эмодзи)": "Flag (emoji)",
  "Добавить язык": "Add language",
  "Ваши языки": "Your languages",
  "Изучаемый язык: главная, повторение и статистика показывают его": "Language you're learning: home, review and stats show it",
  "Язык: {0}": "Language: {0}",
  "не выбран": "not selected",
  "Язык": "Language",
  "Выбрать язык": "Choose language",
  "Свой язык…": "Custom language…",
  "Нет соединения. Проверьте интернет.": "No connection. Check the internet.",
  "Сейчас нельзя отправить письмо: почтовый сервис отправляет всего несколько писем в час. Подождите час — или войдите через Google.": "Can't send an email right now: the mail service sends only a few emails an hour. Wait an hour — or sign in with Google.",
  "Почта ещё не подтверждена. Откройте письмо и перейдите по ссылке — или отправьте письмо ещё раз.": "Your email isn't confirmed yet. Open the email and follow the link — or send it again.",
  "Такой аккаунт уже есть. Войдите или восстановите пароль.": "This account already exists. Sign in or reset your password.",
  "Неверный email или пароль.": "Wrong email or password.",
  "Пароль слишком простой — минимум 6 символов.": "Password too simple — at least 6 characters.",
  "В адресе почты ошибка.": "There's a mistake in the email address.",
  "Регистрация по почте выключена.": "Email sign-up is turned off.",
  "Вход через Google ещё не включён в настройках Supabase.": "Google sign-in isn't enabled in Supabase settings yet.",
  "Ошибка": "Error",
  "Письмо отправлено ещё раз на {0}.": "Email sent again to {0}.",
  "Введите email": "Enter your email",
  "Письмо отправлено на {0}. Откройте его и перейдите по ссылке.": "Email sent to {0}. Open it and follow the link.",
  "Нет соединения.": "No connection.",
  "Заполни email и пароль": "Fill in email and password",
  "Аккаунт создан!": "Account created!",
  "Письмо для подтверждения отправлено на {0}. Откройте его и перейдите по ссылке. Нет письма — проверьте «Спам».": "A confirmation email was sent to {0}. Open it and follow the link. No email — check Spam.",
  "Пароль": "Password",
  "Войдите, чтобы открыть проекты": "Sign in to open your projects",
  "Создайте аккаунт — это бесплатно": "Create an account — free",
  "Сбросить пароль по email": "Reset password by email",
  "Войти": "Sign in",
  "Создать аккаунт": "Create account",
  "Отправить письмо": "Send email",
  "Аккаунт заблокирован": "Account banned",
  "Причина:": "Reason:",
  "Администратор завершил ваш сеанс. Войдите снова.": "An administrator ended your session. Please sign in again.",
  "Продолжить с Google": "Continue with Google",
  "или по почте": "or with email",
  "name@example.com": "you@example.com",
  "минимум 6 символов": "at least 6 characters",
  "Забыли пароль?": "Forgot password?",
  "Отправить письмо ещё раз": "Send the email again",
  "Загрузка...": "Loading...",
  "← Назад к входу": "← Back to sign in",
  "Нет аккаунта? ": "No account? ",
  "Уже есть аккаунт? ": "Already have an account? ",
  "Зарегистрироваться": "Sign up",
  "Регистрируясь, вы соглашаетесь с": "By signing up, you agree to the",
  "Назад": "Back",
  "Квиз": "Quiz",
  "Источник": "Source",
  "Все проекты": "All projects",
  "По папке": "By folder",
  "Выбрать проекты": "Choose projects",
  "карт.": "cards",
  "Направление": "Direction",
  "Слово → Перевод": "Word → Translation",
  "Перевод → Слово": "Translation → Word",
  "Нет карточек": "No cards",
  "Просмотр карточек": "Browse cards",
  "Листайте все карточки": "Flip through all cards",
  "Повторение (FSRS)": "Review (FSRS)",
  "Удержание": "Retention",
  "% · сегодня:": "% · today:",
  "нов.,": "new,",
  "повт.": "reviews",
  "✓ Дневной лимит достигнут": "✓ Daily limit reached",
  "{0} к повторению": "{0} to review",
  "Настройки FSRS": "FSRS settings",
  "% · день с": "% · day starts at",
  "Стоп": "Stop",
  "Озвучка: {0}": "Read aloud: {0}",
  "фронт": "front",
  "бек": "back",
  "выкл": "off",
  "Редактировать": "Edit",
  "Удержание: {0}%": "Retention: {0}%",
  "Редактировать карточку": "Edit card",
  "Слово / фраза": "Word / phrase",
  "Перевод": "Translation",
  "Сохранить": "Save",
  "повтор {0}д": "review {0}d",
  "обучение": "learning",
  "нажмите, чтобы перевернуть": "tap to flip",
  "Показать ответ": "Show answer",
  "Не знаю": "Don't know",
  "Трудно": "Hard",
  "Знаю": "Know",
  "1 · 2 · 3 — оценка, пробел — «Знаю»": "1 · 2 · 3 — rate, space — “Know”",
  "Пробел — показать ответ": "Space — show answer",
  "Цель выполнена!": "Goal reached!",
  "Повторено": "Reviewed",
  "· Ещё": "· More",
  "доступно": "available",
  "Продолжить (": "Continue (",
  "Выход": "Exit",
  "Сессия завершена!": "Session complete!",
  "Следующие повторения": "Next reviews",
  "Ещё раз": "Again",
  "Отлично!": "Excellent!",
  "Хорошо!": "Good!",
  "Учись дальше!": "Keep learning!",
  "правильно": "correct",
  "неверно": "wrong",
  "Выбор режима": "Choose mode",
  "Слово": "Word",
  "нажмите, чтобы увидеть перевод": "tap to see the translation",
  "← Назад": "← Back",
  "Далее →": "Next →",
  "Готово ✓": "Done ✓",
  "← тяни чтобы изменить →": "← drag to change →",
  "с": "s",
  "{0} на {1} с": "{0} by {1} s",
  "Вперёд": "Forward",
  "Пауза": "Pause",
  "Играть": "Play",
  "Снять повтор": "Stop repeat",
  "Зациклить последние {0} с": "Loop the last {0} s",
  "Клип {0} с": "Clip {0} s",
  "Держите, чтобы слушать на {0}×": "Hold to listen at {0}×",
  "Держать {0}×": "Hold {0}×",
  "Скорость": "Speed",
  "Скорость {0}×": "Speed {0}×",
  "Открыть плеер": "Open player",
  "Перемотка": "Seek",
  "Мини-плеер": "Mini player",
  "Предыдущая карточка": "Previous card",
  "Следующая карточка": "Next card",
  "Громкость": "Volume",
  "— не использовать —": "— don't use —",
  "Слово / выражение": "Word / expression",
  "Перевод / значение": "Translation / meaning",
  "Предложение с контекстом": "Sentence with context",
  "Предложение-клоуз ({{c1::слово}})": "Cloze sentence ({{c1::word}})",
  "Чтение / транскрипция": "Reading / transcription",
  "Источник (название текста)": "Source (text title)",
  "Аудио (TTS)": "Audio (TTS)",
  "Настройки AnkiConnect": "AnkiConnect settings",
  "URL сервера": "Server URL",
  "Подключить": "Connect",
  "Как подключить Anki": "How to connect Anki",
  "Откройте Anki на компьютере. Инструменты → Дополнения → Получить дополнения → код": "Open Anki on your computer. Tools → Add-ons → Get Add-ons → code",
  "(AnkiConnect) → перезапустите Anki.": "(AnkiConnect) → restart Anki.",
  "Инструменты → Дополнения → AnkiConnect →": "Tools → Add-ons → AnkiConnect →",
  "Настройки": "Settings",
  ". Найдите строку": ". Find the line",
  "и замените её на эту (без неё Anki не пускает сайт — поэтому кнопки «ничего не делали»):": "and replace it with this one (without it Anki blocks the site — that's why the buttons “did nothing”):",
  "Строка скопирована — вставьте её в настройки AnkiConnect": "Line copied — paste it into the AnkiConnect settings",
  "Копировать": "Copy",
  "Нажмите OK, перезапустите Anki и нажмите «Подключить». Если браузер спросит про доступ к локальной сети — разрешите.": "Press OK, restart Anki and press “Connect”. If the browser asks about local network access — allow it.",
  "Колода": "Deck",
  "— выберите колоду —": "— choose a deck —",
  "Колода для каждого языка": "Deck for each language",
  "Слова на этом языке уйдут в свою колоду. Можно выбрать существующую или вписать новое имя — Anki создаст её сам. Пусто — общая колода выше.": "Words in this language go to their own deck. Pick an existing one or type a new name — Anki creates it. Empty — the common deck above.",
  "Тип карточки (модель)": "Card type (note type)",
  "— выберите модель —": "— choose a note type —",
  "Соответствие полей": "Field mapping",
  "Введите шаблон для каждого поля. Доступные переменные:": "Enter a template for each field. Available variables:",
  "Поле Anki": "Anki field",
  "Шаблон": "Template",
  "Теги (через пробел)": "Tags (separated by spaces)",
  "≈ {0}× ревью vs дефолт (0.90)": "≈ {0}× reviews vs default (0.90)",
  "≈ {0}× реже vs дефолт (0.90)": "≈ {0}× less often vs default (0.90)",
  "Настройки повторения": "Review settings",
  "Желаемое удержание (Retention)": "Desired retention",
  "70% — меньше повторений": "70% — fewer reviews",
  "97% — крепче память": "97% — stronger memory",
  "Выше значение = лучше память, но": "Higher value = better memory, but",
  "больше ежедневных повторений": "more daily reviews",
  ". Рекомендуем 90% (дефолт FSRS).": ". We recommend 90% (FSRS default).",
  "Что это значит на практике": "What it means in practice",
  "была через 7д →": "was in 7d →",
  "д": "d",
  "была через 30д →": "was in 30d →",
  "была через 180д →": "was in 180d →",
  "Stability карты при удачном «Знаю» × (1.0..3.4) — растёт быстрее при низком retention. 90% — компромисс между «помнить надёжно» и «не утонуть в повторениях».": "Card stability after a successful “Know” × (1.0..3.4) — grows faster at low retention. 90% is a compromise between “remember reliably” and “don't drown in reviews”.",
  "Начало нового дня": "Start of a new day",
  "часов утра": "a.m.",
  "Карточки со сроком до этого часа считаются сегодняшними. Если занимаетесь поздно ночью — поставьте 4 (как в Anki) или 6.": "Cards due before this hour count as “today”. If you study late at night — set 4 (like Anki) or 6.",
  "Дневные лимиты": "Daily limits",
  "Новые карты": "New cards",
  "Повторения": "Reviews",
  "Лимит на сессию повторения. 0 = без лимита.": "Limit per review session. 0 = no limit.",
  "Порядок показа": "Display order",
  "Новые:": "New:",
  "Сначала карточки, которые вы сейчас учите, потом повторения — самые просроченные первыми. Новые берутся по порядку проектов (его можно поменять перетаскиванием: панель «Повторение» → «Порядок»), внутри проекта — по месту в аудио.": "Cards you're learning first, then reviews — most overdue first. New cards follow the project order (drag to change it: “Review” → “Order”), inside a project — by position in the audio.",
  "↺ Сбросить": "↺ Reset",
  "{0}ч {1}м": "{0}h {1}m",
  "{0}м": "{0}m",
  "Дневная цель": "Daily goal",
  "Карточек в день": "Cards per day",
  "Изменить": "Change",
  "Цель достигнута": "Goal reached",
  "слушали": "listened",
  "читали": "read",
  "Ещё карточки": "More cards",
  "Начать повторение": "Start review",
  "Порядок проектов": "Project order",
  "Колоды на сегодня": "Today's decks",
  "Порядок, в котором берутся новые карточки": "Order in which new cards are taken",
  "Порядок": "Order",
  "Выбранные:": "Selected:",
  "Новые карточки берутся сверху вниз. Перетащите проект за ручку слева.": "New cards are taken top to bottom. Drag a project by the handle on the left.",
  "Перетащить": "Drag",
  "Выше": "Up",
  "Ниже": "Down",
  "Проект": "Project",
  "Учу": "Learning",
  "Повтор": "Review",
  "Выбрать «{0}»": "Select “{0}”",
  "Выбрать несколько колод": "Select several decks",
  "{0} из {1} карточек пройдено": "{0} of {1} cards done",
  "Всего на сегодня:": "Total for today:",
  "Все слова · {0}": "All words · {0}",
  "Все слова (Тексты)": "All words (Texts)",
  "Повторить словарь": "Review vocabulary",
  "Нет слов для повторения": "No words to review",
  "Помечайте слова уровнями 1–3 в читалке — они появятся здесь.": "Mark words with levels 1–3 in the reader — they'll show up here.",
  "Готово!": "Done!",
  "правильно (": "correct (",
  "Уровень": "Level",
  "✗ Не знаю": "✗ Don't know",
  "✓ Знаю!": "✓ I know!",
  "Нет карточек с переводом — сначала добавьте перевод": "No cards with a translation — add a translation first",
  "Переместить в папку": "Move to folder",
  "Без папки": "No folder",
  "отправляю в Anki…": "sending to Anki…",
  "в Anki: {0} добавлено{1}": "to Anki: {0} added{1}",
  ", {0} уже было": ", {0} already there",
  "Anki не открыт или нет AnkiConnect": "Anki isn't open or AnkiConnect is missing",
  "Нет текста в проекте.": "The project has no text.",
  "Нет слов для повторения.\nПомечайте слова уровнями 1–3 в читалке.": "No words to review.\nMark words with levels 1–3 in the reader.",
  "Слушать": "Listen",
  "Квиз по карточкам": "Card quiz",
  "Открыть текст": "Open text",
  "Переименовать": "Rename",
  "Удалить офлайн-копию": "Delete offline copy",
  "Аудио останется в облаке": "The audio stays in the cloud",
  "Скачать для офлайна": "Download for offline",
  "Слушать без интернета": "Listen without internet",
  "Отправить в Anki": "Send to Anki",
  "Anki должен быть открыт": "Anki must be open",
  "Скачать для Anki (.txt)": "Download for Anki (.txt)",
  "Настройки Anki": "Anki settings",
  "Читать": "Read",
  "Квиз по словам": "Word quiz",
  "Слова уровней 1–3 из этого текста": "Level 1–3 words from this text",
  "Привязано к аудио — изменить": "Linked to audio — change",
  "Привязать к аудио": "Link to audio",
  "Удалить папку": "Delete folder",
  "Проекты из неё останутся в библиотеке": "Its projects stay in the library",
  "Новое название": "New name",
  "Скачано: работает без интернета": "Downloaded: works without internet",
  "Действия": "Actions",
  "{0} аудио": "{0} audio",
  "пусто": "empty",
  "остановились на {0}": "stopped at {0}",
  "есть текст": "has text",
  "Не скачалось — повторить": "Didn't download — retry",
  "Повторить скачивание": "Retry download",
  "с аудио": "with audio",
  "Без названия": "Untitled",
  "Текст": "Text",
  "Привязать «{0}» к аудио": "Link “{0}” to audio",
  "Аудиопроектов пока нет.": "No audio projects yet.",
  "Отвязать от аудио": "Unlink from audio",
  "Сортировка": "Sort",
  "Изменённые": "Recently changed",
  "А–Я": "A–Z",
  "Скачано {0} из {1}. Не удалось: {2}.": "Downloaded {0} of {1}. Failed: {2}.",
  "Назад, на главную": "Back to home",
  "Скачать все аудио папки, чтобы слушать без интернета": "Download all audio in the folder to listen offline",
  "{0} из {1}": "{0} of {1}",
  "Скачать всё": "Download all",
  "Добавить": "Add",
  "Папка пуста": "Folder is empty",
  "Добавьте аудио или текст — или перетащите их сюда с главной.": "Add audio or a text — or drag them here from home.",
  "Аудио проект": "Audio project",
  "Синхронизация не удалась": "Sync failed",
  ". Изменения сохранены на устройстве и отправятся сами, когда появится связь.": ". Changes are saved on the device and will be sent automatically when you're back online.",
  "Закрыть объявление": "Close announcement",
  "Название папки": "Folder name",
  "Создать": "Create",
  "Ничего не найдено": "Nothing found",
  "Найдено: {0}": "Found: {0}",
  "200+ карточек": "200+ cards",
  "Нет карточек со словом «": "No cards with the word “",
  "Повторить сегодня": "Review today",
  "Начать": "Start",
  "На сегодня всё": "All done for today",
  "Цель: {0} в день. Изменить — в разделе «Повторение».": "Goal: {0} a day. Change it in “Review”.",
  "Позанимайтесь сегодня, чтобы не потерять серию": "Study today to keep your streak",
  "Стрик": "Streak",
  "позанимайтесь сегодня": "study today",
  "рекорд {0}": "record {0}",
  "Играть здесь": "Play here",
  "Продолжить:": "Continue:",
  " · остановились на {0}": " · stopped at {0}",
  "Библиотека": "Library",
  "Добро пожаловать!": "Welcome!",
  "Загрузите аудио и добавляйте карточки прямо во время прослушивания — или начните с текста.": "Upload audio and add cards right while listening — or start with a text.",
  "Новый проект": "New project",
  "Выберите аудиофайл для этого проекта.": "Choose an audio file for this project.",
  "Выберите аудиофайл — он загрузится в облако и будет доступен офлайн.": "Choose an audio file — it uploads to the cloud and becomes available offline.",
  "Сжимаем аудио…": "Compressing audio…",
  "WAV → Opus · в 5–10 раз меньше": "WAV → Opus · 5–10 times smaller",
  "Загружаем в облако…": "Uploading to the cloud…",
  "Для длинных файлов — минута-две": "Long files take a minute or two",
  "Нажмите или перетащите файл": "Click or drag a file here",
  "Импорт текста": "Import text",
  "Вставьте слова и переводы. Можно начать строку с таймкода": "Paste words and translations. Optional: start a line with a timestamp",
  "чтобы задать время карточки.": "to set the card's time.",
  "apple\tяблоко\n0:30\tcat\tкот\n1:15\tdog\tсобака": "apple\tяблоко\n0:30\tcat\tкот\n1:15\tdog\tсобака",
  "Разделитель (между словом и переводом)": "Separator (between word and translation)",
  "Запятая (,)": "Comma (,)",
  "Другой": "Other",
  "Введите разделитель": "Enter a separator",
  "Предпросмотр —": "Preview —",
  "Вставьте текст выше": "Paste text above",
  "...и ещё": "...and",
  "Импортировать": "Import",
  "нет интернета": "no internet",
  "сервер не ответил за 15 секунд": "the server didn't answer in 15 seconds",
  "вход устарел — выйдите и войдите снова": "sign-in expired — sign out and in again",
  "нет связи с сервером": "no connection to the server",
  "Перемотать к этому моменту": "Jump to this moment",
  "перевод ▾": "translation ▾",
  "Остановить цикл": "Stop loop",
  "Зациклить эту карточку": "Loop this card",
  "Не удалось найти субтитры в файле.": "Couldn't find subtitles in the file.",
  "Импортировано {0}. Пропущено {1} (за пределами аудио).": "Imported {0}. Skipped {1} (outside the audio).",
  "Импортировано {0}!": "Imported {0}!",
  "SRS повторение проекта": "SRS review of the project",
  "Вдумчивый режим включён — слушание идёт в зачёт уровня": "Focused mode is on — listening counts toward your level",
  "Включить вдумчивый режим: активное прослушивание считается отдельно и продвигает уровень": "Turn on focused mode: active listening is counted separately and moves your level up",
  "Сейчас играет": "Now playing",
  "Загружено": "Loaded",
  "−{0}с": "−{0}s",
  "Загружается…": "Loading…",
  "Пауза (пробел)": "Pause (space)",
  "Играть (пробел)": "Play (space)",
  "+{0}с": "+{0}s",
  "Снять повтор (C)": "Stop repeat (C)",
  "Зациклить последние {0} с (клавиша C)": "Loop the last {0} s (key C)",
  "Держите, чтобы слушать на {0}× (клавиша S)": "Hold to listen at {0}× (key S)",
  "Держать: {0}×": "Hold: {0}×",
  "+ карточку на": "+ card at",
  "Настройки воспроизведения": "Playback settings",
  "Перемотка:": "Skip:",
  "Цикл": "Loop",
  "Скорость:": "Speed:",
  "Задержка:": "Delay:",
  "Поставить A": "Set A",
  "Поставить B": "Set B",
  "Клип: последние": "Clip: last",
  "Замедление:": "Slow down:",
  "Клавиши:": "Keys:",
  "— зациклить последние секунды (ещё раз — снять),": "— loop the last seconds (again — stop),",
  "(держать) — слушать медленно. Вместе: услышали непонятное место → C → держите S.": "(hold) — listen slowly. Together: heard an unclear bit → C → hold S.",
  "Офлайн-копия": "Offline copy",
  "✓ Скачано": "✓ Downloaded",
  "Загрузка {0}%...": "Downloading {0}%...",
  "⚠ Ошибка": "⚠ Error",
  "Не скачано": "Not downloaded",
  "Удалить офлайн-копию? Проект останется в списке.": "Delete the offline copy? The project stays in the list.",
  "Удалить загрузку": "Delete download",
  "⟳ Повторить": "⟳ Retry",
  "Скачать офлайн": "Download offline",
  "Текст · {0}": "Text · {0}",
  "Текст пустой — откройте его в читалке и добавьте.": "The text is empty — open it in the reader and add it.",
  "Читалка: перевод слов по нажатию, карточки, озвучка": "Reader: tap words to translate, cards, read-aloud",
  "Открыть в читалке": "Open in the reader",
  "Отвязать текст от этого аудио? Сам текст останется в библиотеке.": "Unlink the text from this audio? The text itself stays in the library.",
  "Отвязать": "Unlink",
  "Вставьте текст этого аудио: расшифровку, статью, субтитры…": "Paste the text of this audio: transcript, article, subtitles…",
  "Сохраняю…": "Saving…",
  "Сохранить текст": "Save text",
  "или привязать готовый текст:": "or link an existing text:",
  "Вернуть на место": "Put it back",
  "↩ на место": "↩ back",
  "Зациклить карточку": "Loop card",
  "Закрепить карточку": "Pin card",
  "нажмите → перевод": "tap → translation",
  "Карточки": "Cards",
  "Автоскролл вкл": "Auto-scroll on",
  "Перейти к текущей": "Go to current",
  "Выбрать все": "Select all",
  "Зациклить выбранные": "Loop selected",
  "Удалить {0}?": "Delete {0}?",
  "Удалить{0}": "Delete{0}",
  "Отмена выбора": "Cancel selection",
  "Отменить (Ctrl+Z)": "Undo (Ctrl+Z)",
  "Выбрать несколько": "Select several",
  "Импорт SRT/VTT": "Import SRT/VTT",
  "ПКМ на таймлайне или кнопка выше": "Right-click on the timeline or the button above",
  "Новая карточка": "New card",
  "Текущий ·": "Current ·",
  "Слово или фраза": "Word or phrase",
  "напр. résoudre": "e.g. résoudre",
  "Снять все": "Unselect all",
  "нажмите для перевода": "tap for translation",
  "{0}ч": "{0}h",
  "＋ Добавить": "＋ Add",
  "− Вычесть": "− Subtract",
  "минут": "minutes",
  "слов": "words",
  "мин": "min",
  "Сегодня": "Today",
  "Всё время": "All time",
  "Статистика": "Stats",
  "Все языки": "All languages",
  "Пока нет данных — начните читать или слушать": "No data yet — start reading or listening",
  "Слушание": "Listening",
  "Уровень {0}": "Level {0}",
  "Старт": "Start",
  " · до ": " · to ",
  "ч": "h",
  "Скорректировать вручную (например, добавить часы прослушивания вне приложения)": "Adjust manually (for example, add listening hours outside the app)",
  "/ {0}ч": "/ {0}h",
  "Вдумчиво:": "Focused:",
  "+ Фоном:": "+ Background:",
  "Чтение": "Reading",
  "Скорректировать вручную": "Adjust manually",
  "Прослушано": "Listened",
  "вдумчиво:": "focused:",
  "Прочитано слов": "Words read",
  "время:": "time:",
  "По языкам": "By language",
  "Без языка": "No language",
  "Старые записи, у которых не было языка:": "Old records that had no language:",
  " · чтение {0}": " · reading {0}",
  "За период": "For the period",
  "Период": "Period",
  "Слов прочитано": "Words read",
  "Знакомых слов": "Known words",
  "Лучший стрик:": "Best streak:",
  "Опасная зона": "Danger zone",
  "Очистить статистику · {0}": "Clear stats · {0}",
  "Очистить всю статистику (все языки)": "Clear all stats (all languages)",
  "Проекты, тексты и карточки сохранятся —": "Projects, texts and cards stay —",
  "удалятся только цифры": "only the numbers are deleted",
  "этого языка": "of this language",
  "по всем языкам": "for all languages",
  "Прослушано · сегодня": "Listened · today",
  "Прочитано слов · сегодня": "Words read · today",
  "всех языков": "of all languages",
  "записей без языка": "of records without a language",
  "Очистить статистику?": "Clear stats?",
  "Будут удалены все цифры {0}:\n": "All numbers {0} will be deleted:\n",
  "• {0} прослушивания\n": "• {0} of listening\n",
  "• {0} прочитанных слов\n": "• {0} words read\n",
  "карточка": "card",
  "карточки": "cards",
  "карточек": "cards",
  "активный день": "active day",
  "активных дня": "active days",
  "активных дней": "active days",
  "Контент (проекты, тексты, словарь) НЕ удаляется. ": "Content (projects, texts, vocabulary) is NOT deleted. ",
  "У вас будет 6 секунд, чтобы отменить действие.": "You'll have 6 seconds to undo.",
  "↶ Отменить": "↶ Undo",
  "Сохранено": "Saved",
  "Введите текущий пароль": "Enter your current password",
  "Новый пароль — минимум 6 символов": "New password — at least 6 characters",
  "Новый пароль совпадает со старым": "The new password is the same as the old one",
  "Неверный текущий пароль": "Wrong current password",
  "Не удалось сменить пароль": "Couldn't change the password",
  "Пароль изменён. Другие устройства выйдут из аккаунта в течение часа.": "Password changed. Other devices will be signed out within an hour.",
  "Не удалось отправить письмо": "Couldn't send the email",
  "Письмо отправлено на {0}.": "Email sent to {0}.",
  "Выйти на всех других устройствах? Здесь вы останетесь в аккаунте.": "Sign out on all other devices? You'll stay signed in here.",
  "Другие устройства выйдут из аккаунта в течение часа.": "Other devices will be signed out within an hour.",
  "Не удалось. Проверьте интернет.": "Failed. Check the internet.",
  "Выйти на всех устройствах, включая это?": "Sign out on all devices, including this one?",
  "Профиль": "Profile",
  "Имя": "Name",
  "Видно под вашими разборами слов в общей библиотеке. Почту никто не видит.": "Shown under your word notes in the shared library. Nobody sees your email.",
  "Например, Антон": "For example, Anton",
  "Учёба": "Study",
  "Язык, цель на день, повторение": "Language, daily goal, review",
  "Изучаемый язык": "Language you're learning",
  "Главная, повторение и статистика показывают его.": "Home, review and stats show it.",
  " · для этого языка": " · for this language",
  "Меньше": "Less",
  "Больше": "More",
  "Алгоритм повторения": "Review algorithm",
  "Сколько помнить, лимиты новых карточек, начало дня": "How much to remember, new card limits, start of day",
  "Отправка карточек в программу Anki": "Sending cards to the Anki app",
  "Оформление": "Appearance",
  "Тема": "Theme",
  "Светлая": "Light",
  "Тёмная": "Dark",
  "Аркада": "Arcade",
  "Тема «Аркада»": "Arcade theme",
  "Звуки интерфейса": "Interface sounds",
  "Щелчки кнопок и ноты ответов. Молчат, пока играет аудио.": "Button clicks and answer notes. Silent while audio is playing.",
  "Верных ответов подряд": "Correct answers in a row",
  "Джекпот!": "Jackpot!",
  "Рой слов, Тир, Лови, Пары · пиявок: {0}": "Word Swarm, Shooting, Catch, Pairs · leeches: {0}",
  "Рой слов, Тир, Лови, Пары": "Word Swarm, Shooting, Catch, Pairs",
  "Чтобы играть, нужно хотя бы {0} карточки со словом и переводом — сейчас {1}. Слово — не длиннее {2} знаков.": "To play you need at least {0} cards with a word and a translation — you have {1}. Words up to {2} characters.",
  "Не то слово!": "Wrong word!",
  "База · волна {0}": "Base · wave {0}",
  "Сбито: {0}": "Shot down: {0}",
  "Поле игры «Рой слов»": "Word Swarm playing field",
  "Рой слов": "Word Swarm",
  "На вас ползут слова из ваших карточек — герой сам стреляет в ближайшие.": "Words from your cards crawl towards you — your hero shoots the nearest ones by itself.",
  "Рекорд: {0}": "Best: {0}",
  "Новый уровень!": "Level up!",
  "Выберите улучшение": "Choose an upgrade",
  "ур. {0}": "lv. {0}",
  "Слова задушили!": "The words got you!",
  "Новый рекорд!": "New record!",
  "Волна: {0}": "Wave: {0}",
  "Принесено: {0}": "Delivered: {0}",
  "Слова ползут на вас — хватайте нужные и несите на базу. Улучшения каждый уровень. Сколько продержитесь?": "Words crawl towards you — grab the right ones and carry them to the base. Upgrades every level. How long will you last?",
  "Скорострельность": "Fire rate",
  "Стреляете на 20% чаще": "Shoot 20% more often",
  "Залп": "Volley",
  "+1 снаряд за выстрел": "+1 projectile per shot",
  "Пробивание": "Piercing",
  "Снаряд пробивает ещё одно слово": "Projectiles pass through one more word",
  "Урон": "Damage",
  "Снаряды бьют на 1 сильнее": "Projectiles hit 1 harder",
  "Двигаетесь на 15% быстрее": "Move 15% faster",
  "Магнит": "Magnet",
  "≈ {0} {1}": "≈ {0} {1}",
  "минута": "minute",
  "минуты": "minutes",
  "Стрик {0} {1}": "{0}-{1} streak",
  "Бонусный опыт": "Bonus XP",
  "Твой ход, {0}.": "Your move, {0}.",
  "Твой ход.": "Your move.",
  "{0} каждый день. По одной хорошей руке.": "{0} every day. One good hand at a time.",
  "Каждый день. По одной хорошей руке.": "Every day. One good hand at a time.",
  "Маленькая сессия.": "A small session.",
  "Большой прогресс.": "Big progress.",
  "Твоя колода на сегодня уже на столе.": "Today's deck is already on the table.",
  "Сыграй {0} {1} и закрой план.": "Play {0} {1} and close today's plan.",
  "карточку": "card",
  "На сегодня всё сыграно. Новые карточки появятся завтра.": "Everything is played for today. New cards come tomorrow.",
  "{0} знакомых + {1} новых": "{0} familiar + {1} new",
  "Остановились на {0}": "Stopped at {0}",
  "Немного удачи между занятиями.": "A little luck between lessons.",
  "Главная ставка — твои знания.": "Your knowledge is the real bet.",
  "Учись. Повторяй. Собирай свою колоду.": "Learn. Review. Build your deck.",
  "Каждая карточка — в твою пользу.": "Every card works in your favour.",
  "Тема «{0}» — для Pro": "The “{0}” theme is for Pro",
  "Только в Pro": "Pro only",
  "Тема «Колода»": "“Deck” theme",
  "Вас добило слово": "The word that finished you",
  "Почти!": "So close!",
  "Слоты": "Slots",
  "Крутится…": "Spinning…",
  "Крутите — выпадет слово": "Spin to draw a word",
  "Крутить": "Spin",
  "Внизу база с тремя переводами — набор. Перед каждым набором игра покажет слова: запомните их.": "At the bottom is the base with three translations — a set. Before each set the game shows the words: remember them.",
  "Нажмите на нужное слово рядом с героем — он его схватит.": "Tap the right word near the hero to grab it.",
  "Сбитые слова роняют опыт, а каждое принесённое слово даёт ещё больше. Весь набор принесён — новый уровень и улучшение.": "Shot words drop experience, and every delivered word gives even more. Deliver the whole set for a new level and an upgrade.",
  "Запомните слова": "Remember the words",
  "Набор {0}: запомните слова": "Set {0}: remember the words",
  "Найдите их в рое и принесите на базу.": "Find them in the swarm and bring them to the base.",
  "Вперёд!": "Go!",
  "Или коснитесь перевода на базе — он станет целью, и герой схватит нужное слово, просто наехав на него. Наехали на не то — ранит.": "Or tap a translation on the base — it becomes the target, and the hero grabs the right word just by running into it. Run into the wrong one and it hurts.",
  "Ведите пальцем по полю — герой идёт следом. Касание перевода на базе — цель, касание слова — схватить, слова в руках — бросить.": "Drag a finger across the field and the hero follows. Tap a translation on the base to set the target, tap a word to grab it, tap the word in your hands to drop it.",
  "WASD или стрелки — идти, щелчок по слову — схватить, по переводу на базе — цель, пробел — бросить, P или Esc — пауза.": "WASD or arrows to move, click a word to grab it, click a translation on the base to set the target, Space to drop, P or Esc to pause.",
  "Руки заняты: несите на базу или бросьте слово": "Hands full: take it to the base or drop the word",
  "Волна {0}!": "Wave {0}!",
  "Блок!": "Blocked!",
  "Отнесите слово на базу. Не то слово отскочит и ранит — взяли не то, бросьте его.": "Carry the word to the base. A wrong word bounces back and hurts — grabbed the wrong one? Drop it.",
  "Сбитое слово лежит {0} секунды — его тоже можно схватить.": "A shot-down word lies there for {0} seconds — you can grab it too.",
  "Крит": "Critical hit",
  "Шанс 12% ударить втрое сильнее": "12% chance to hit three times harder",
  "Молния": "Lightning",
  "Бьёт ближайшее слово и перескакивает на соседние": "Strikes the nearest word and jumps to its neighbours",
  "Взрыв": "Blast",
  "Сбитое слово взрывается и задевает соседей": "A shot-down word explodes and hits its neighbours",
  "Жгучая аура": "Burning aura",
  "Обжигает слова вокруг вас": "Burns the words around you",
  "Щит": "Shield",
  "Гасит один удар и восстанавливается за несколько секунд": "Absorbs one hit and recharges in a few seconds",
  "Регенерация": "Regeneration",
  "Здоровье понемногу восстанавливается": "Health slowly comes back",
  "Опыт притягивается на 40% дальше": "Experience is pulled in from 40% further",
  "Длинные руки": "Long arms",
  "Хватаете слова на 30% дальше": "Grab words from 30% further",
  "Длинные слова и фразы приходят с {0}-й волны: медленные, но крепкие.": "Long words and phrases arrive from wave {0}: slow but tough.",
  "Броня": "Armor",
  "+25 к здоровью и столько же лечения": "+25 max health and as much healing",
  "Аптечка": "First aid",
  "Восстановить половину здоровья": "Restore half your health",
  "Орбита": "Orbit",
  "Вокруг вас кружит ещё одна фишка": "One more chip circles around you",
  "Холод": "Frost",
  "Слова рядом с вами замедляются": "Words near you slow down",
  "Ударная волна": "Shockwave",
  "Раз в несколько секунд отбрасывает слова": "Every few seconds it pushes words away",
  "Рюкзак": "Backpack",
  "Нести на одно слово больше": "Carry one more word",
  "Нажмите слово, которое значит:": "Tap the word that means:",
  "Поймайте слово, которое значит:": "Catch the word that means:",
  "Корзина": "Basket",
  "Водите пальцем или мышью по полю, на компьютере — стрелки ← →": "Move your finger or mouse over the field; on a computer use the ← → keys",
  "Жизни: {0}": "Lives: {0}",
  "Осталось: {0}": "Left: {0}",
  "Игры для запоминания": "Memory games",
  "Тир, Лови, Пары · пиявок: {0}": "Shooting, Catch, Pairs · leeches: {0}",
  "Тир, Лови, Пары": "Shooting, Catch, Pairs",
  "Пиявки": "Leeches",
  "Накопилось пиявок: {0}": "Leeches piled up: {0}",
  "Карточки, которые вы часто забываете. Закрепите их в играх.": "Cards you keep forgetting. Lock them in with games.",
  "Закрепить": "Practice",
  "Пиявки сняты!": "Leeches cleared!",
  "Игры": "Games",
  "К играм": "To games",
  "Заново": "Restart",
  "Закрепляйте слова в коротких играх. Расписание повторения не меняется.": "Lock words in with short games. Your review schedule doesn't change.",
  "Верно: {0} из {1}": "Correct: {0} of {1}",
  "Время: {0}": "Time: {0}",
  "Снято пиявок: {0}": "Leeches cleared: {0}",
  "Пиявки — карточки, которые вы забыли {0} раза и больше. {1} верных ответа в играх — и пиявка снята.": "Leeches are cards you have forgotten {0} times or more. {1} right answers in games clear a leech.",
  "Пиявок нет — все трудные карточки закреплены.": "No leeches — all hard cards are locked in.",
  "Нужно хотя бы 4 карточки со словом и переводом.": "You need at least 4 cards with a word and a translation.",
  "Каждый раз — {0} случайных карточек изучаемого языка.": "Each game uses {0} random cards of the language you're learning.",
  "Найдите пары: слово и его перевод": "Find the pairs: a word and its translation",
  "Стреляйте в слово, которое значит:": "Shoot the word that means:",
  "Тир": "Shooting",
  "Лови": "Catch",
  "Пары": "Pairs",
  "Слова летают — стреляйте в то, что значит перевод сверху.": "Words fly around — shoot the one that means the translation above.",
  "Ловите корзиной верное слово, от остальных уворачивайтесь.": "Catch the right word in the basket, dodge the rest.",
  "Найдите пары: слово и его перевод — на время.": "Match each word with its translation — against the clock.",
  "ИИ-помощник": "AI helper",
  "Свои ключи для разборов слов — по желанию": "Your own keys for word notes — optional",
  "Ключ OpenRouter": "OpenRouter key",
  "Без ключа ИИ-объяснения работают через общий лимит сайта. Свой ключ — бесплатно на": "Without a key, AI explanations use the site's shared limit. Your own key — free at",
  ". Хранится только на этом устройстве.": ". Stored only on this device.",
  "Безопасность": "Security",
  "Пароль и устройства": "Password and devices",
  "Сменить пароль": "Change password",
  "Текущий пароль": "Current password",
  "Новый пароль (от 6 символов)": "New password (6+ characters)",
  "Новый пароль": "New password",
  "Забыли? Письмо для сброса": "Forgot? Reset email",
  "Устройства": "Devices",
  "Выйти на других устройствах": "Sign out on other devices",
  "Выйти везде": "Sign out everywhere",
  "Выйти из аккаунта": "Sign out",
  "Условия": "Terms",
  "Конфиденциальность": "Privacy",
  "Авторские права": "Copyright",
  "Версия": "Version",
  "Повторение": "Review",
  "{0} на сегодня": "{0} for today",
  "На сегодня всё повторено": "All reviewed for today",
  "Здесь появятся карточки из ваших аудиопроектов": "Cards from your audio projects will appear here",
  "Все карточки": "All cards",
  " · с видео": " · with video",
  "Тексты и книги для чтения": "Texts and books to read",
  "Книга из файла": "Book from a file",
  "Новый текст": "New text",
  "Страница": "Page",
  "Все тексты": "All texts",
  "Начните с первого текста": "Start with your first text",
  "Вставьте статью или главу, загрузите книгу EPUB/TXT или привяжите видео с YouTube.": "Paste an article or a chapter, upload an EPUB/TXT book or link a YouTube video.",
  "Главная": "Home",
  "Ошибка загрузки: ": "Upload error: ",
  "Недостаточно места на диске.{0}{1} Освободите место и попробуйте снова.": "Not enough disk space.{0}{1} Free up some space and try again.",
  " Файл: ~{0} МБ.": " File: ~{0} MB.",
  " Свободно: ~{0} МБ.": " Free: ~{0} MB.",
  "Возможно, мало места: ~{0} МБ свободно, нужно ~{1} МБ для {2} файлов. Продолжить?": "Space may be low: ~{0} MB free, ~{1} MB needed for {2} files. Continue?",
  "Аудио «{0}» удалён": "Audio “{0}” deleted",
  "Папка «{0}» удалена": "Folder “{0}” deleted",
  "шаг 1 (audio): {0}": "step 1 (audio): {0}",
  "не отправлено изменений: {0}{1} — повторю сам": "changes not sent: {0}{1} — will retry",
  "Текст «{0}» удалён": "Text “{0}” deleted",
  "Вся статистика очищена": "All stats cleared",
  "Записи без языка очищены": "Records without a language cleared",
  "Статистика «{0}» очищена": "Stats “{0}” cleared",
  "Загрузка…": "Loading…",
  "Поиск по карточкам": "Search cards",
  "Синхронизация…": "Syncing…",
  "Синхронизировать сейчас": "Sync now",
  "Не удалось: {0}": "Failed: {0}",
  "нет связи": "no connection",
  "В очереди: {0}": "Queued: {0}",
  "Аккаунт и настройки": "Account and settings",
  "Карточки поверх окон": "Cards over other windows",
  "Alt+Q — показать или скрыть": "Alt+Q — show or hide",
  "Нажмите Alt+Q — карточки появятся поверх всех окон.": "Press Alt+Q — cards will appear over all windows.",
  "Выйти": "Sign out",
  "Создать в «{0}»": "Create in “{0}”",
  "Карточки по ходу прослушивания": "Cards while you listen",
  "Статья, глава, субтитры": "Article, chapter, subtitles",
  "EPUB или TXT": "EPUB or TXT",
  "Папка": "Folder",
  "Вышло обновление AntonCards": "AntonCards update available",
  "Обновить": "Update",
  "Загружаю последнюю версию…": "Downloading the latest version…",
  "Не удалось обновить. Попробуйте ещё раз.": "Couldn't update. Please try again.",
  "Вышла новая версия приложения": "A new version of the app is out",
  "Скачать": "Download",
  "Разделы": "Sections",
  "Новый": "New",
  "русский": "Russian",
  "английский": "English",
  "украинский": "Ukrainian",
  "немецкий": "German",
  "французский": "French",
  "испанский": "Spanish",
  "итальянский": "Italian",
  "португальский": "Portuguese",
  "польский": "Polish",
  "турецкий": "Turkish",
  "японский": "Japanese",
  "китайский": "Chinese",
  "корейский": "Korean",
  "общий словарь": "shared dictionary",
  "ИИ-словарь": "AI dictionary",
  "Язык перевода": "Translation language",
  "{0}   (Tab — вставить)": "{0}   (Tab — insert)",
  "напр. решать": "e.g. to solve",
  "Добавлять чтение каной перед переводом": "Add the kana reading before the translation",
  "кана:": "kana:",
  "Ищу перевод…": "Looking up a translation…",
  "Подсказок нет — впишите перевод сами": "No suggestions — type the translation yourself",
  "Укажите язык проекта, чтобы появились подсказки перевода.": "Set the project's language to get translation suggestions.",
  "Очистить поиск": "Clear search",
  "Аккаунт": "Account",
  "Низкая": "Low",
  "Средняя": "Medium",
  "Высокая": "High",
  "Очень высокая": "Very high",
  "Максимальная": "Maximum",
  "На счёте Anthropic закончились деньги. Пополните баланс в console.anthropic.com.": "Your Anthropic balance is empty. Top it up at console.anthropic.com.",
  "Ключ Claude не подходит. Проверьте, что он скопирован целиком.": "The Claude key doesn't work. Check that it was copied in full.",
  "У этого ключа нет доступа к модели.": "This key has no access to the model.",
  "Такой модели нет. Выберите другую в настройках.": "No such model. Choose another one in settings.",
  "Слишком много запросов. Подождите минуту.": "Too many requests. Wait a minute.",
  "Claude сейчас перегружен. Попробуйте чуть позже.": "Claude is overloaded right now. Try again a bit later.",
  "Ошибка Claude ({0}): {1}": "Claude error ({0}): {1}",
  "нет сети": "no network",
  "Нет связи с Claude. Проверьте интернет.": "No connection to Claude. Check the internet.",
  "Claude отказался отвечать на этот запрос.": "Claude declined to answer this request.",
  "Ответ не поместился. Попробуйте меньшую глубину размышлений.": "The answer didn't fit. Try a lower thinking depth.",
  "Claude ответил не в том формате. Попробуйте ещё раз.": "Claude answered in the wrong format. Try again.",
  "Смешной факт": "Funny fact",
  "Грустный факт": "Sad fact",
  "Жуткий факт": "Creepy fact",
  "Удивительный факт": "Amazing fact",
  "Исторический факт": "Historical fact",
  "Ключ не подошёл": "The key didn't work",
  "С ключом Claude в читалке есть подробный разбор слова (происхождение, как запомнить) и перевод всей страницы. Ключ — на console.anthropic.com, оплата за использование.": "With a Claude key the reader gives a detailed word note (origin, how to remember) and translates the whole page. Get a key at console.anthropic.com, pay as you go.",
  "Ключ Claude": "Claude key",
  "Проверяю…": "Checking…",
  "Сохранить и проверить": "Save and check",
  "✓ Ключ работает": "✓ The key works",
  "Ключ хранится только в этом браузере и уходит только в Anthropic.": "The key is stored only in this browser and goes only to Anthropic.",
  "Модель для разборов": "Model for word notes",
  "за 1M токенов": "per 1M tokens",
  "Глубина размышлений": "Thinking depth",
  "Один разбор ≈ $": "One note ≈ $",
  ". Словарь страницы — Claude Haiku 5.5, доли цента. В этом месяце: $": ". Page dictionary — Claude Haiku 5.5, a fraction of a cent. This month: $",
  "Делиться разборами в общей библиотеке": "Share word notes in the shared library",
  "Файл больше 25 МБ.": "The file is larger than 25 MB.",
  "Часть {0}": "Part {0}",
  "в файле не нашлось текста": "no text found in the file",
  "Это не похоже на книгу EPUB. Книги с защитой от копирования (DRM) прочитать нельзя.": "This doesn't look like an EPUB book. Books with copy protection (DRM) can't be read.",
  "Файл не прочитался: {0}": "Couldn't read the file: {0}",
  "Книга": "Book",
  "Загружаю {0} из {1}…": "Uploading {0} of {1}…",
  "Импорт остановился: {0}": "Import stopped: {0}",
  "📚 Книга из файла": "📚 Book from a file",
  "EPUB или TXT до 25 МБ. Книга станет папкой, каждая глава — текстом в ней. Файл читается здесь, в браузере; на сервер уходят только выбранные главы.": "EPUB or TXT up to 25 MB. The book becomes a folder, each chapter a text in it. The file is read here in the browser; only the chosen chapters go to the server.",
  "Читаю файл…": "Reading the file…",
  "Выбрать файл": "Choose a file",
  "Название (папка)": "Title (folder)",
  "Язык книги": "Book language",
  "Найдено глав:": "Chapters found:",
  ". Снимите галочки с лишнего — обложки и оглавления уже сняты.": ". Uncheck what you don't need — covers and tables of contents are already unchecked.",
  "сл.": "w.",
  "Загрузить {0} гл.": "Upload {0} ch.",
  "Другой файл": "Another file",
  "файл внутри книги слишком большой": "a file inside the book is too large",
  "неизвестное сжатие": "unknown compression",
  "Что-то сломалось": "Something broke",
  "Произошла ошибка в приложении. Обновите страницу; если ошибка повторится — скопируйте текст ниже и пришлите его нам.": "Something went wrong in the app. Reload the page; if it happens again, copy the text below and send it to us.",
  "Перезагрузить": "Reload",
  "Попробовать продолжить": "Try to continue",
  "Библиотека ещё не создана в Supabase.": "The library isn't set up in Supabase yet.",
  "Нужно один раз выполнить supabase_migration_admin.sql в Supabase (SQL Editor).": "Run supabase_migration_admin.sql once in Supabase (SQL Editor).",
  "Журнала ещё нет: выполните supabase_migration_client_errors.sql в Supabase.": "No log yet: run supabase_migration_client_errors.sql in Supabase.",
  "нет ответа сервера за {0} с": "no server response in {0} s",
  "Не синхронизировано": "Not synced",
  "Нужна настройка базы": "Database setup needed",
  "Изменения сохранены на устройстве и отправятся сами": "Changes are saved on the device and will be sent automatically",
  "Синхронизировано": "Synced",
  "AntonCards — главная": "AntonCards — home",
  "Синхр.": "Sync",
  "Очередь": "Queue",
  "сейчас": "now",
  "{0} мин": "{0} min",
  "{0}д": "{0}d",
  "{0}мес": "{0}mo",
  "{0}г": "{0}y",
  "Новая": "New",
  "Сейчас": "Now",
  "Через {0}м": "In {0}m",
  "Скоро": "Soon",
  "Завтра": "Tomorrow",
  "Через {0}д": "In {0}d",
  "Вперемешку с повторениями": "Mixed with reviews",
  "После повторений": "After reviews",
  "Перед повторениями": "Before reviews",
  "— нет перевода —": "— no translation —",
  "Не удалось получить объяснение": "Couldn't get an explanation",
  "Добавлено в «{0}»": "Added to “{0}”",
  "Уже есть в колоде": "Already in the deck",
  "фразу «{0}»": "the phrase “{0}”",
  "слово «{0}»": "the word “{0}”",
  "Удалить {0}? Это уберёт перевод, статус и SRS-прогресс.": "Delete {0}? This removes the translation, status and SRS progress.",
  "Узнаю": "Recognize",
  "Знакомо": "Familiar",
  "Выучено": "Learned",
  "Знаю ✓": "Know ✓",
  "Фраза": "Phrase",
  "Прослушать произношение": "Listen to the pronunciation",
  "Скопировано": "Copied",
  "Скопировать": "Copy",
  "Остановить": "Stop",
  "Спросить заново": "Ask again",
  "Объяснение от ИИ (грамматика, контекст)": "AI explanation (grammar, context)",
  "Подробный разбор: происхождение, история, факт (Claude и общая библиотека)": "Detailed note: origin, history, fact (Claude and the shared library)",
  "✓ Сохранено": "✓ Saved",
  "Пропущено": "Skipped",
  "Скопировать перевод": "Copy translation",
  "скопировано": "copied",
  "копировать": "copy",
  "Перевожу…": "Translating…",
  "Свой перевод…": "Your own translation…",
  "ИИ-объяснение": "AI explanation",
  "печатает…": "typing…",
  "В заметки": "To notes",
  "Запрашиваю объяснение…": "Requesting an explanation…",
  "Заметки": "Notes",
  "Пример, контекст…": "Example, context…",
  "Уровень — нажмите, чтобы сохранить": "Level — tap to save",
  "Отправляем…": "Sending…",
  "Добавить в Anki": "Add to Anki",
  "Пропустить": "Skip",
  "Удалить карточку": "Delete card",
  "Удалить фразу": "Delete phrase",
  "новых": "new",
  "учу": "learning",
  "знаю": "know",
  "Правильно!": "Correct!",
  "Правильный ответ: ": "Correct answer: ",
  "Cloze Quiz — заполни пропуски (": "Cloze Quiz — fill in the blanks (",
  "слов)": "words)",
  "верно": "right",
  "Перемотать видео к этому моменту": "Jump the video to this moment",
  "Продолжить": "Continue",
  "Убрать из цикла (Shift+click — диапазон)": "Remove from loop (Shift+click — range)",
  "Зациклить (Shift+click — диапазон)": "Loop (Shift+click — range)",
  "Словарь готов: {0} сл. · ~${1}": "Dictionary ready: {0} w. · ~${1}",
  "Все слова страницы уже в словаре": "All words on the page are already in the dictionary",
  "Не получилось": "Didn't work",
  "Нажмите, чтобы переименовать": "Click to rename",
  "Статистика по языку": "Stats for the language",
  "Словарь страницы: Claude переведёт все новые слова этой страницы (доли цента), перевод появится у всех в общем словаре": "Page dictionary: Claude translates all new words on this page (a fraction of a cent), and the translation appears for everyone in the shared dictionary",
  "Словарь…": "Dictionary…",
  "Словарь": "Dictionary",
  "Остановить чтение": "Stop reading",
  "Прочитать страницу вслух (голос и скорость — в меню языка)": "Read the page aloud (voice and speed — in the language menu)",
  "Вслух": "Aloud",
  "Квиз по словам этого текста": "Quiz on words from this text",
  "Нет слов для повторения.\nПомечайте слова уровнями 1–3.": "No words to review.\nMark words with levels 1–3.",
  "Выйти из режима пропусков": "Exit fill-in-the-blanks mode",
  "Пропуски: изучаемые слова скрываются, их нужно вспомнить": "Blanks: words you're learning are hidden, you need to recall them",
  "Выйти из режима фразы": "Exit phrase mode",
  "Режим фразы — нажимайте слова по очереди, чтобы собрать фразу": "Phrase mode — tap words one by one to build a phrase",
  "Фраза: вкл": "Phrase: on",
  "Скрыть видео": "Hide video",
  "Показать YouTube-видео": "Show the YouTube video",
  "Прикрепить YouTube-видео к этому тексту": "Attach a YouTube video to this text",
  "Языки и озвучка": "Languages and voice",
  "С языка": "From",
  "На язык": "To",
  "Скорость речи": "Speech rate",
  "Голос": "Voice",
  "Авто (": "Auto (",
  "Японский: слова делятся по словарю (kuromoji)": "Japanese: words are split by the dictionary (kuromoji)",
  "Быстрый перевод — MyMemory (бесплатно)": "Quick translation — MyMemory (free)",
  "Изменить текст": "Edit text",
  "Добавить текст": "Add text",
  "Словарь загружен ✓": "Dictionary loaded ✓",
  "Ошибка: {0}": "Error: {0}",
  "Индексирую словарь…": "Indexing the dictionary…",
  "Загружаю японский словарь…": "Loading the Japanese dictionary…",
  "Повторить": "Retry",
  "Очистить кеш словаря и скачать заново — если предыдущий кеш битый": "Clear the dictionary cache and download again — if the previous cache is broken",
  "Сброс": "Reset",
  "Один раз ~17 МБ — потом работает без интернета. Читать можно уже сейчас: пока словарь грузится, слова делятся приблизительно.": "One time ~17 MB — after that it works offline. You can read right away: while the dictionary loads, words are split approximately.",
  "Сделать фразу из «{0}»?": "Make a phrase from “{0}”?",
  "Нажимайте слова по очереди": "Tap words one by one",
  "Очистить выделение": "Clear selection",
  "Сохранить фразу (откроется карточка)": "Save phrase (a card will open)",
  "✓ Сохранить": "✓ Save",
  "ТЯНИ": "DRAG",
  "ТЯНИ К КРАЮ — РЯДОМ С ТЕКСТОМ": "DRAG TO THE EDGE — NEXT TO THE TEXT",
  "Закрепить сверху": "Pin to the top",
  "Видео слева, текст справа": "Video on the left, text on the right",
  "Видео справа, текст слева": "Video on the right, text on the left",
  "Открепить — вернуть в обычный режим": "Unpin — back to normal mode",
  "ВИДЕО": "VIDEO",
  "СЛЕВА": "LEFT",
  "СПРАВА": "RIGHT",
  "Перенести на другую сторону": "Move to the other side",
  "Плавающее окно": "Floating window",
  "Над текстом": "Above the text",
  "Потяните, чтобы изменить ширину": "Drag to change the width",
  "Потяните, чтобы изменить размер": "Drag to resize",
  "Окно": "Window",
  "Плавающее окно — читать и смотреть одновременно": "Floating window — read and watch at the same time",
  "Открепить": "Unpin",
  "Сверху": "Top",
  "Видео снова прокручивается с текстом": "The video scrolls with the text again",
  "Закрепить видео сверху, текст прокручивается под ним": "Pin the video at the top, the text scrolls under it",
  "◧ Слева": "◧ Left",
  "Видео слева, текст справа (как Snap в Windows)": "Video on the left, text on the right (like Windows Snap)",
  "Справа ◨": "Right ◨",
  "↺ сброс": "↺ reset",
  "Отпустите — видео встанет": "Release — the video will dock",
  "слева": "left",
  "справа": "right",
  "сверху": "top",
  "Добавьте текст, чтобы начать читать": "Add a text to start reading",
  "Все слова сначала": "All words start",
  "синие": "blue",
  ". Сохранённые фразы —": ". Saved phrases are",
  "фиолетовые": "purple",
  "Вставить текст": "Paste text",
  "Загрузить файл": "Upload file",
  "Новое": "New",
  "Выделено": "Selected",
  "Стр.": "P.",
  "из": "of",
  "Отмечаю…": "Marking…",
  "Конец": "End",
  "Дальше →": "Next →",
  "✓ Прочитано": "✓ Read",
  "✓ Прочитано, дальше →": "✓ Read, next →",
  "Все новые слова этой страницы станут «знаю»": "All new words on this page will become “know”",
  "Новые слова этой страницы станут «знаю», и откроется следующая": "New words on this page will become “know”, and the next page opens",
  "Перетащить панель (двойной щелчок — вернуть в угол)": "Drag the panel (double-click — back to the corner)",
  "Воспроизвести": "Play",
  "Развернуть панель": "Expand panel",
  "Текущая позиция / длительность": "Current position / duration",
  "Назад на 5 секунд": "Back 5 seconds",
  "Назад на 2 секунды": "Back 2 seconds",
  "Вперёд на 2 секунды": "Forward 2 seconds",
  "Вперёд на 5 секунд": "Forward 5 seconds",
  "Автопауза включена — пауза после каждой строки": "Auto-pause on — pause after each line",
  "Включить паузу после каждой строки": "Pause after each line",
  "Авто": "Auto",
  "Скорость воспроизведения": "Playback speed",
  "Снять все циклы": "Remove all loops",
  "Свернуть панель": "Collapse panel",
  "Вставить": "Paste",
  "Файл": "File",
  "Вставьте статью, рассказ или расшифровку…": "Paste an article, a story or a transcript…",
  "Перетащите файл сюда или нажмите, чтобы выбрать": "Drop a file here or click to choose",
  "Подходят: .txt, .md, .srt, .vtt": "Supported: .txt, .md, .srt, .vtt",
  "Прикреплено": "Attached",
  " · {0} отрезков": " · {0} segments",
  "✕ Открепить видео": "✕ Detach video",
  "Вставьте ссылку, чтобы заменить видео…": "Paste a URL to replace the video…",
  "Ссылка на YouTube (например, https://youtube.com/watch?v=…)": "YouTube link (e.g., https://youtube.com/watch?v=…)",
  "Видео найдено:": "Video found:",
  "Открыть на YouTube": "Open on YouTube",
  "Транскрипция необязательна — без неё видео просто прикрепится.": "A transcript is optional — without it the video is just attached.",
  "С транскрипцией будет синхронизация по таймкодам:": "With a transcript you get timestamp sync:",
  "1. На YouTube: «…» → «Показать транскрипцию»": "1. On YouTube: “…” → “Show transcript”",
  "2. Скопируйте текст и вставьте ниже": "2. Copy the text and paste it below",
  "Вставьте расшифровку с YouTube (необязательно — для синхронизации)…": "Paste the YouTube transcript (optional — for sync)…",
  "✓ Найдено": "✓ Found",
  "временны́х отрезков — синхронизация будет доступна": "time segments — sync will be available",
  "Заменить видео": "Replace video",
  "Прикрепить видео": "Attach video",
  " (текст не трогаем)": " (text stays as is)",
  "Заменить текст транскрипцией": "Replace the text with the transcript",
  "Загрузить транскрипцию как текст": "Load the transcript as text",
  "слов ·": "words ·",
  "знаков": "characters",
  "0 МБ": "0 MB",
  "{0} ГБ": "{0} GB",
  "{0} МБ": "{0} MB",
  "слово": "word",
  "слова": "words",
  "Anki не отвечает — откройте Anki и проверьте «Настройки AnkiConnect»": "Anki isn't responding — open Anki and check “AnkiConnect settings”",
  "Вы": "You",
  "Удалить этот разбор?": "Delete this word note?",
  "Разбор слова {0}": "Word note: {0}",
  "Произнести": "Pronounce",
  "Ищу разборы в библиотеке…": "Looking for notes in the library…",
  "Ваш": "Yours",
  "Здесь, в этом предложении": "Here, in this sentence",
  "Происхождение": "Origin",
  "История": "History",
  "Факт": "Fact",
  "Родственные слова": "Related words",
  "Как запомнить": "How to remember",
  "Ваш разбор": "Your note",
  "Автор: {0}": "Author: {0}",
  " · только на этом устройстве": " · only on this device",
  "Убрать лайк": "Remove like",
  "Нравится": "Like",
  "Виден всем": "Visible to everyone",
  "Только мне": "Only me",
  "Взять перевод": "Use the translation",
  "Разбора этого слова в библиотеке пока нет. Сделайте первый — он появится у всех, кто читает на этом языке.": "There's no note for this word in the library yet. Make the first one — everyone reading in this language will see it.",
  "Разбора этого слова пока нет. Подробные разборы делает Claude: добавьте свой ключ в Аккаунт → «Claude: разбор слов». Разборы других учеников видны и без ключа.": "There's no note for this word yet. Detailed notes are made by Claude: add your key in Settings → AI helper. Other learners' notes are visible without a key.",
  "Claude разбирает слово…": "Claude is working on the word…",
  "Пожелание (необязательно): «проще», «больше истории»…": "Wish (optional): “simpler”, “more history”…",
  "Новый разбор": "New note",
  "Разобрать с Claude": "Explain with Claude",
  "Язык интерфейса": "Interface language",
  "Как в системе": "Same as system",
  "Сейчас: {0}": "Now: {0}",
  "Приложение перезапустится на выбранном языке.": "The app will restart in the chosen language.",
  "Завершите вход в открывшемся браузере — потом приложение откроется само.": "Finish signing in in the browser that opened — then the app opens by itself.",
  "Не удалось завершить вход: {0}": "Couldn't finish signing in: {0}",
  "Новый пароль совпадает с прежним — придумайте другой.": "The new password is the same as the old one — choose another.",
  "Этот пароль слишком простой или уже встречался в утечках — придумайте другой.": "This password is too simple or has appeared in data leaks — choose another.",
  "Для смены пароля войдите заново и повторите.": "To change the password, sign in again and repeat.",
  "Вдумчивый режим": "Focused mode",
  "Вдумчиво": "Focused",
  "Своя нейросеть или ключи — по желанию": "Your own model or keys — optional",
  "Вы перешли по ссылке из письма. Придумайте новый пароль для {0}.": "You followed the link from the email. Choose a new password for {0}.",
  "Пароль сохранён. Входите с ним на всех устройствах.": "Password saved. Use it on all your devices.",
  "Скрыть пароль": "Hide password",
  "Показать пароль": "Show password",
  "Позже": "Later",
  "Сохранить пароль": "Save password",
  "ИИ": "AI",
  "Нет такой модели или адреса: {0}": "No such model or address: {0}",
  "Нет связи с нейросетью ({0}). Проверьте адрес и интернет.": "No connection to the AI ({0}). Check the address and the internet.",
  "Нейросеть ответила не в том формате. Попробуйте ещё раз или другую модель.": "The AI answered in the wrong format. Try again or another model.",
  "Пустой ответ — проверьте название модели.": "Empty answer — check the model name.",
  "Укажите адрес и модель": "Enter the address and the model",
  "Своя нейросеть": "Your own AI",
  "Любой сервис с API как у OpenAI: объяснения, разборы слов и словарь страницы пойдут через него. Ключ хранится только на этом устройстве.": "Any service with an OpenAI-style API: explanations, word notes and the page dictionary will go through it. The key is stored only on this device.",
  "Сервис": "Service",
  "— выберите —": "— choose —",
  "Другой (свой адрес)": "Other (your own address)",
  "Адрес API": "API address",
  "Ключ": "Key",
  "где взять": "get one",
  "не нужен": "not needed",
  "Модель": "Model",
  "✓ Работает — теперь объяснения и разборы идут через {0}": "✓ Works — explanations and word notes now go through {0}",
  "Разбора этого слова пока нет. Подробные разборы делает ИИ: добавьте ключ Claude или свою нейросеть в Настройки → «ИИ-помощник». Разборы других учеников видны и без ключа.": "There's no note for this word yet. Detailed notes are made by AI: add a Claude key or your own AI in Settings → AI helper. Other learners' notes are visible without a key.",
  "{0} разбирает слово…": "{0} is working on the word…",
  "Разобрать с ИИ": "Explain with AI",
  "Озвучка": "Read aloud",
  "Снова": "Again",
  "Хорошо": "Good",
  "Легко": "Easy",
  "1 · 2 · 3 · 4 — оценка, пробел — «Хорошо»": "1 · 2 · 3 · 4 — rate, space — “Good”",
  "Максимальный интервал": "Maximum interval",
  "Карточка не уйдёт дальше этого срока, даже если вы её хорошо помните. 36500 — без ограничения.": "A card won't be scheduled further out than this, even if you know it well. 36500 — no limit.",
  "{0} из {1} строк позже конца этого аудио. Если это часть разрезанного файла — с какого времени она начинается? Например 30:00. Пусто — без сдвига.": "{0} of {1} lines are after the end of this audio. If it is part of a split file — where does this part start? For example 30:00. Empty — no shift.",
  "Шаги заучивания": "Learning steps",
  "После «Снова»": "After “Again”",
  "нет": "none",
  "Шаги переучивания": "Relearning steps",
  "Через сколько карточка вернётся, пока вы её учите: m — минуты, h — часы, d — дни, через пробел. «Хорошо» ведёт на следующий шаг, после последнего карточка уходит в повторение. По умолчанию 1m 10m и 10m, как в Anki.": "How soon a card comes back while you're learning it: m — minutes, h — hours, d — days, separated by spaces. “Good” moves to the next step; after the last one the card goes to review. Default 1m 10m and 10m, as in Anki.",
  "EPUB, PDF или TXT": "EPUB, PDF or TXT",
  "PDF больше 80 МБ.": "The PDF is larger than 80 MB.",
  "Читаю страницу {0} из {1}…": "Reading page {0} of {1}…",
  "PDF не открылся — файл повреждён или это не PDF.": "The PDF didn't open — the file is damaged or isn't a PDF.",
  "PDF защищён паролем — снимите защиту и попробуйте снова.": "The PDF is password-protected — remove the protection and try again.",
  "В PDF нет текста — похоже, это скан (картинки страниц). Такие пока не читаются.": "There's no text in this PDF — it looks like a scan (page images). Those can't be read yet.",
  "Не загрузился модуль чтения PDF — проверьте интернет.": "The PDF reader didn't load — check the internet.",
  "EPUB, PDF или TXT. Книга станет папкой, каждая глава — текстом в ней. Файл читается здесь, на устройстве; на сервер уходят только выбранные главы.": "EPUB, PDF or TXT. The book becomes a folder, each chapter a text in it. The file is read here, on your device; only the chosen chapters go to the server.",
  "Очередь: {0}": "Queue: {0}",
  "Убрать из очереди": "Remove from queue",
  "Сейчас №{0} в очереди": "Now #{0} in the queue",
  "Играть следующим": "Play next",
  "Сразу после текущего аудио": "Right after the current audio",
  "Добавить в очередь": "Add to queue",
  "В конец очереди": "At the end of the queue",
  "в очереди: {0}": "in queue: {0}",
  "Открыть очередь": "Open the queue",
  "Далее: {0}": "Next: {0}",
  "Очередь: аудио одно за другим": "Queue: audios one after another",
  "Найти аудио": "Find audio",
  "Нет аудио с загруженным звуком.": "No audio with uploaded sound.",
  "уже в очереди": "already in the queue",
  "играет сейчас": "playing now",
  "играет": "playing",
  "на паузе": "paused",
  "Далее": "Up next",
  "Очередь пуста. Добавьте аудио — они будут играть одно за другим, как выпуски подкаста.": "The queue is empty. Add audios — they'll play one after another, like podcast episodes.",
  "Выбрать аудио": "Choose audios",
  "Играть сейчас": "Play now",
  "Убрать из очереди: {0}": "Remove from queue: {0}",
  "Играет по порядку, одно за другим": "Plays in order, one after another",
  "Добавить аудио": "Add audio",
  "Добавить: {0}": "Add: {0}",
  "Очистить очередь?": "Clear the queue?",
  "Уровень растёт от вдумчивого слушания. Включите «Вдумчиво» в плеере — и время пойдёт в зачёт.": "Your level grows from focused listening. Turn on “Focused” in the player and the time will count.",
  "Аудио для проекта": "Audio for the project",
  "Новое аудио": "New audio",
  "показать полностью ▾": "show all ▾",
  "Скопировать текст ошибки": "Copy the error text",
  "Громкость {0}% — колёсико мыши меняет": "Volume {0}% — the mouse wheel changes it",
  "Включить звук": "Unmute",
  "Выключить звук": "Mute",
  "Медленнее": "Slower",
  "Обычная": "Normal",
  "Быстрее": "Faster",
  "Быстро": "Fast",
  "{0}: к повторению {1}": "{0}: {1} due",
  "{0}: ничего не запланировано": "{0}: nothing scheduled",
  "{0}: повторено {1}": "{0}: {1} reviewed",
  "{0}: без повторений": "{0}: no reviews",
  "Предыдущий год": "Previous year",
  "Следующий год": "Next year",
  "В среднем": "Daily average",
  "Дней с занятиями": "Days studied",
  "Рекорд": "Record",
  "Серия": "Streak",
  "Проект — нажмите, чтобы повторить только его": "Project — tap to review only this one",
  "Повторить «{0}»": "Review “{0}”",
  "Повторить карточки": "Review cards",
  "Только этот проект": "Only this project",
  "Скачать карточки (.txt)": "Download cards (.txt)",
  "Для Anki и других программ": "For Anki and other apps",
  "Отменено": "Undone",
  "{0} забанен навсегда": "{0} banned for good",
  "{0}: тайм-аут {1}": "{0}: timeout {1}",
  "на день": "for a day",
  "на {0} дней": "for {0} days",
  "Разбанить": "Unban",
  "{0} разбанен": "{0} unbanned",
  "Тайм-аут на день": "Timeout for a day",
  "Тайм-аут на 7 дней": "Timeout for 7 days",
  "Забанить навсегда": "Ban for good",
  "Бан с причиной…": "Ban with a reason…",
  "Причину увидит пользователь": "The user will see the reason",
  "{0} выкинут со всех устройств": "{0} signed out on all devices",
  "Тариф: сделать Pro": "Plan: make Pro",
  "{0} теперь админ": "{0} is now an admin",
  "Отменить": "Undo",
  "Удалить аккаунт": "Delete account",
  "Удалить аккаунт {0}?": "Delete the account {0}?",
  "Удалятся все его аудио, карточки, тексты, словарь и статистика. Вернуть будет нельзя.": "All their audio, cards, texts, vocabulary and stats will be deleted. This can't be undone.",
  "Удалить навсегда": "Delete for good",
  "Сейчас повторять нечего": "Nothing to review right now",
  "На сегодня всё!": "All done for today!",
  "Цель на сегодня выполнена!": "Today's goal is done!",
  "Подход готов!": "Round done!",
  "Повторено: {0}": "Reviewed: {0}",
  "Карточки, которые вы сейчас учите, вернутся через несколько минут.": "The cards you're learning now will come back in a few minutes.",
  "Новые карточки появятся завтра.": "New cards will come tomorrow.",
  "Осталось на сегодня: {0} · ≈ {1} мин": "Left for today: {0} · ≈ {1} min",
  "Всё, что было на сегодня, повторено. Возвращайтесь завтра!": "Everything for today is reviewed. Come back tomorrow!",
  "Хватит на сегодня": "Enough for today",
  "Ещё {0}": "{0} more",
  "ещё {0} новых — в следующие дни": "{0} more new — on the next days",
  "≈ {0} мин": "≈ {0} min",
  "{0} на сегодня · ≈ {1} мин": "{0} for today · ≈ {1} min",
  "План на сегодня выполнен!": "Today's plan is done!",
  "План на сегодня": "Today's plan",
  "Меньше новых в день": "Fewer new per day",
  "Больше новых в день": "More new per day",
  "Выполнен": "Done",
  "уже пройденные": "already learned",
  "ещё {0} ждут": "{0} more waiting",
  "из нового": "new ones",
  "Новых карточек в день": "New cards per day",
  "Сделано сегодня: {0}": "Done today: {0}",
  "На сегодня всё — возвращайтесь завтра": "All done for today — come back tomorrow",
  "повторить {0} · новых {1}": "review {0} · new {1}",
  "Сколько из плана на сегодня уже сделано": "How much of today's plan is done",
  "Язык, новые в день, повторение": "Language, new per day, review",
  "Плюс повторение уже пройденных — сколько им пора": "Plus reviewing the learned ones that are due",
  "Повторить {0} · новых {1} · ≈ {2} мин": "Review {0} · new {1} · ≈ {2} min",
  "Ссылка из письма устарела или уже использована. Нажмите «Забыли пароль?» — придёт новая.": "The link from the email has expired or was already used. Tap “Forgot password?” — a new one will come.",
  "Вход через Google есть в новой версии приложения. Если вы входили через Google, нажмите «Забыли пароль?»: придёт письмо, задайте пароль — и входите по почте.": "Sign-in with Google is in the new version of the app. If you signed in with Google, tap “Forgot password?”: an email will come, set a password — and sign in with your email.",
  "Пароль задан. Теперь можно входить и по почте с паролем — например, в приложении на телефоне.": "Password set. Now you can also sign in with your email and password — for example, in the phone app.",
  "Задать пароль": "Set a password",
  "Вы входите через Google — пароля у аккаунта пока нет. Задайте его, чтобы входить и по почте.": "You sign in with Google — the account has no password yet. Set one to also sign in with your email.",
  "Загрузка идёт в браузере телефона. Когда скачается — откройте файл AntonCards.apk и нажмите «Установить». Ваши данные сохранятся.": "The download is going in your phone's browser. When it finishes, open the file AntonCards.apk and tap “Install”. Your data will stay.",
  "К повторению": "Review",
  "К повторению: {0}, новых: {1}": "To review: {0}, new: {1}",
  "к повторению": "to review",
  "Играть «{0}»": "Play “{0}”",
  "Аудио": "Audio",
  "Аудио с карточками по ходу прослушивания": "Audio with cards made while you listen",
  "Все аудио": "All audio",
  "Начните с первого аудио": "Start with your first audio",
  "Загрузите подкаст, аудиокнигу или запись — и добавляйте карточки прямо во время прослушивания.": "Upload a podcast, audiobook or recording — and add cards right while you listen.",
  "Выбрать карточку {0}": "Select card {0}",
  "Перемотать к {0}": "Jump to {0}",
  "Убрать A-B": "Clear A-B",
  "Время": "Time",
  "Выйти на других устройствах?": "Sign out on other devices?",
  "Здесь вы останетесь в аккаунте.": "You will stay signed in here.",
  "Удалить «{0}»": "Delete “{0}”",
  "Удалить «{0}»?": "Delete “{0}”?",
  "Карточки и статистика останутся.": "Cards and stats will stay.",
  "Язык папки «{0}»": "Language of folder “{0}”",
  "Это уберёт перевод, статус и SRS-прогресс.": "This removes the translation, status and review progress.",
  "Сдвинуть субтитры?": "Shift the subtitles?",
  "Снять выделение": "Deselect all",
  "Остановить повтор A–B": "Stop A–B repeat",
  "Повторять отрезок A–B": "Repeat A–B",
  "Открепить все": "Unpin all",
  "На телефоне нет голоса для этого языка. Его можно добавить в настройках Android: «Синтез речи».": "Your phone has no voice for this language. You can add one in Android settings: «Text-to-speech».",
  "Озвучка появится после обновления приложения.": "Pronunciation will work after you update the app.",
  "Этот браузер не умеет произносить слова.": "This browser can’t pronounce words."
};
export default dict;
